import React from "react";
import { ProdesegDropdown } from "../prodeseg-dropdown/ProdesegDropdown";
import { ProdesegDropdownToggle } from "../prodeseg-dropdown/ProdesegDropdownToggle";
import { ProdesegDropdownMenu } from "../prodeseg-dropdown/ProdesegDropdownMenu";
import { ProdesegButton, ProdesegButtonEnumSizes, ProdesegButtonEnumTypes } from "../ProdesegButton/ProdesegButton";
import { ReactComponent as IconEdit } from "../../assets/img/icon/edit.svg";
import { ReactComponent as IconLeave } from "../../assets/img/icon/leave.svg";
import { useLogout } from "../../custom-hooks/useLogout";
import { LinkUnset } from "../LinkUnset";
import { useUser } from "../../custom-hooks/useUser";
import { ProdesegUserImage } from "./ProdesegUserImage";

export const ProdesegUserProfile: React.FC = () => {
    const { logout } = useLogout();
    const { fullName } = useUser();

    return (
        <article className={"d-flex gap-2 align-items-center"}>
            <div className={"d-flex flex-column align-items-end justify-content-end small text-right fs-12"}>
                <p className={"m-0 text-white fw-medium"}>{fullName}</p>
            </div>
            <ProdesegDropdown>
                {({ setFalse }) => (
                    <>
                        <ProdesegDropdownToggle>
                            <ProdesegUserImage isSmall />
                        </ProdesegDropdownToggle>
                        <ProdesegDropdownMenu className={"p-4 pt-5"} showCloseButton>
                            <div className={"d-flex flex-column gap-4 align-items-center"}>
                                <div
                                    className={"rounded-circle bg-gradient-linear-primary-3"}
                                    style={{ padding: "1px" }}
                                >
                                    <div className={"p-2 rounded-circle bg-white"} style={{ width: "fit-content" }}>
                                        <ProdesegUserImage />
                                    </div>
                                </div>
                                <div className={"text-center"}>
                                    <h6 className={"m-0 fw-medium pb-1"}>{fullName}</h6>
                                </div>
                                <div className={"d-flex flex-wrap gap-4 justify-content-center"}>
                                    <LinkUnset to={"/perfil"}>
                                        <ProdesegButton
                                            type={ProdesegButtonEnumTypes.Primary}
                                            size={ProdesegButtonEnumSizes.Small}
                                            hideIconStart
                                            Icon={IconEdit}
                                            onClick={setFalse}
                                        >
                                            Mi perfil
                                        </ProdesegButton>
                                    </LinkUnset>
                                    <ProdesegButton
                                        type={ProdesegButtonEnumTypes.Dark}
                                        size={ProdesegButtonEnumSizes.Small}
                                        Icon={IconLeave}
                                        hideIconStart
                                        onClick={logout}
                                    >
                                        Cerrar sesión
                                    </ProdesegButton>
                                </div>
                            </div>
                        </ProdesegDropdownMenu>
                    </>
                )}
            </ProdesegDropdown>
        </article>
    );
};
